import { ApolloLink, Observable } from "@apollo/client";
import { pageLoading } from "./pageLoading";

/**
 * Counts every GraphQL operation as page activity. Mark background work (polling, silent
 * retries) with `context: { silent: true }` so it does not keep the bar running.
 */
export const pageLoadingLink = new ApolloLink((operation, forward) => {
  if (operation.getContext().silent) {
    return forward(operation);
  }
  return new Observable((observer) => {
    const end = pageLoading.begin();
    const subscription = forward(operation).subscribe({
      next: (value) => observer.next(value),
      error: (error) => {
        end();
        observer.error(error);
      },
      complete: () => {
        end();
        observer.complete();
      },
    });
    return () => {
      end();
      subscription.unsubscribe();
    };
  });
});
